

import { ConfirmationController } from './controllers/confirmationController';

export function confirmationDirective(): ng.IDirective {
    return <ng.IDirective>{
        template: require("./templates/confirmation.html"),
        controller: ConfirmationController,
        controllerAs: "vm",
        bindToController: {
            trackingId: "=",
            city: "=",
            pickupAddressLine1: "=",
            pickupCountry: "=",
            destinationCountry: "=",
            transportationMode: "=",
            packageType: "=",
            totalShippingCost: "=",
            isPackageSizeGreater: "=",
            isLoading: "=",
            orderNumber: "=",
            deliveryNumber: "=",
            sapErrorMessage: "="
        },
        scope: true
    }
}

angular
    .module("deliveryCreate.app")
    .directive("confirmation", confirmationDirective);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/confirmation/confirmationDirective.ts
 **/